import * as React from "react";
export var validateChildren = function (validTypes, children) {
    var isValid = true;
    React.Children.forEach(children, function (child) {
        var str = child.type.toString();
        var regex = /function ([^\(]*)/ig;
        var m = regex.exec(str);
        if (!m || (child && validTypes.indexOf(m[1]) < 0))
            isValid = false;
    });
    return isValid;
};
export var throwError = function (validTypes, message, children) {
    if (process.env.NODE_ENV === "production")
        return;
    if (!validateChildren(validTypes, children)) {
        throw new Error(message);
    }
};
//# sourceMappingURL=TypeChecking.js.map